import http from '../01_axios'
import type { ApiResponse } from '../01_axios/api/response.api'
import type * as Params from './components/authservice.param'
import * as urls from './components/urls'

const sendOtp = (payload: Params.SendOtpRequest): Promise<ApiResponse<Params.SendOtpResponse>> =>
  http.post(urls.apiSendOtp, payload)
const forgotPassword = (payload: Params.ForgotPasswordRequest): Promise<ApiResponse<string>> =>
  http.post(urls.apiForgotPassword, payload)

const AuthService = {
  sendOtp,
  forgotPassword,
}

export default AuthService
